module.exports = __webpack_public_path__ + "img/babies_03.df6d2a15.jpg";